// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","contentWrap":"_2zcWT-Ko6iFetVK5p67cJd"};